import React from 'react';
import { Weight, Flame, Dumbbell, Activity } from 'lucide-react';

const Specialties = () => {
  return (
    <section className="py-16 bg-white" id="specialties">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            We <span className="text-sky-600">Specialize</span> In
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
          {/* Specialty 1 */}
          <div className="text-center">
            <div className="bg-sky-50 w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-6">
              <Flame className="text-sky-600" size={32} />
            </div>
            <h3 className="font-bold text-xl mb-3 text-gray-900">Weight/Fat Loss</h3>
            <p className="text-gray-700">
              Customized plans to help you lose weight and burn fat efficiently
            </p>
          </div>

          {/* Specialty 2 */}
          <div className="text-center">
            <div className="bg-sky-50 w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-6">
              <Weight className="text-sky-600" size={32} />
            </div>
            <h3 className="font-bold text-xl mb-3 text-gray-900">Toning</h3>
            <p className="text-gray-700">
              Sculpt and define your muscles for a more toned appearance
            </p>
          </div>

          {/* Specialty 3 */}
          <div className="text-center">
            <div className="bg-sky-50 w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-6">
              <Dumbbell className="text-sky-600" size={32} />
            </div>
            <h3 className="font-bold text-xl mb-3 text-gray-900">Strength Training</h3>
            <p className="text-gray-700">
              Build functional strength and conditioning for everyday life
            </p>
          </div>

          {/* Specialty 4 */}
          <div className="text-center">
            <div className="bg-sky-50 w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-6">
              <Activity className="text-sky-600" size={32} />
            </div>
            <h3 className="font-bold text-xl mb-3 text-gray-900">Injury Prevention</h3>
            <p className="text-gray-700">
              Specialized physical therapy approach to prevent and recover from injuries
            </p>
          </div>
        </div>

        <div className="mt-16 text-center">
          <a
            href="#packages"
            className="inline-block bg-sky-600 text-white text-lg px-8 py-4 rounded-xl hover:bg-sky-700 transition duration-300 shadow-lg"
          >
            Click For Pricing Info
          </a>
        </div>

        <div className="mt-16 bg-sky-50 p-8 rounded-xl">
          <h3 className="text-2xl md:text-3xl font-bold mb-6 text-center text-gray-900">
            Who We <span className="text-sky-600">Work With</span>
          </h3>
          <p className="text-xl text-center text-gray-700 max-w-3xl mx-auto">
            We work with a wide variety of people ranging from busy professionals to everyday people who are looking to improve the way they look and feel.
          </p>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mt-10">
            <div className="bg-white p-6 rounded-xl shadow-sm">
              <h4 className="font-bold text-lg mb-2 text-sky-600">Busy Professionals</h4>
              <p className="text-gray-700">
                Efficient workouts and nutrition plans that fit into your demanding schedule
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-sm">
              <h4 className="font-bold text-lg mb-2 text-sky-600">Fitness Beginners</h4>
              <p className="text-gray-700">
                Step-by-step guidance for those just starting their fitness journey
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-sm">
              <h4 className="font-bold text-lg mb-2 text-sky-600">Injury Recovery</h4>
              <p className="text-gray-700">
                Specialized programs for those recovering from injuries or surgeries
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Specialties;